var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"protocol-wrap"},[_c('div',{staticClass:"webview-wrap"},[_c('webview',{attrs:{"src":"https://m.kuaidi100.com/app/frame/protocol.jsp"}})],1),_c('div',{staticClass:"global-btn",on:{"click":_vm.agree}},[_vm._v("同意")])])
}
var staticRenderFns = []

export { render, staticRenderFns }